module.exports = __webpack_public_path__ + "static/hero-1b0aca4fbbd6dc84e8524022a645e585.jpg";